import { useEffect, useRef } from "react";
import { Trash2 } from "lucide-react";
import { CachedImage } from "../../components/ui/CachedImage.jsx";
import { IconButton, ListItemSurface } from "../../components/ui/Primitives.jsx";
import { getGenerationTextResult, getThumbnailImageSrc } from "../../lib/imageAssets.js";

export function HistoryStrip({ history, activeId, onSelect, onRemove }) {
  const stripRef = useRef(null);
  const itemRefs = useRef(new Map());

  useEffect(() => {
    const activeItem = itemRefs.current.get(activeId);
    if (!activeItem) {
      return;
    }
    activeItem.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest",
    });
  }, [activeId, history]);

  if (history.length === 0) {
    return null;
  }
  return (
    <div className="history-strip" ref={stripRef} aria-label="生成历史">
      {history.map((item) => {
        const rejectionText = getGenerationTextResult(item);
        const label = item.prompt || item.model || (rejectionText ? "请求被拒绝" : "Generated image");
        return (
          <article
            className={item.id === activeId ? "history-card active" : "history-card"}
            data-state={item.id === activeId ? "active" : "idle"}
            key={item.id}
            ref={(node) => {
              if (node) {
                itemRefs.current.set(item.id, node);
              } else {
                itemRefs.current.delete(item.id);
              }
            }}
          >
            <ListItemSurface
              className="history-main"
              active={item.id === activeId}
              aria-label={`查看历史记录：${label}`}
              onClick={() => onSelect(item.id)}
            >
              {rejectionText ? (
                <div className="history-text-thumb" aria-hidden="true">
                  <span>拒绝</span>
                </div>
              ) : (
                <span className="history-thumb-wrap">
                  <CachedImage src={getThumbnailImageSrc(item)} alt="" loading="lazy" />
                </span>
              )}
              <span>{label}</span>
            </ListItemSurface>
            <IconButton
              className="remove-history"
              aria-label="删除历史记录"
              title="删除历史记录"
              onClick={(event) => {
                event.stopPropagation();
                onRemove(item.id);
              }}
            >
              <Trash2 size={13} aria-hidden="true" />
            </IconButton>
          </article>
        );
      })}
    </div>
  );
}
